import React, { useEffect } from 'react';
import { ErrorPageContent } from 'services/content';
import styles from './style.module.css';
import { useHistory, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { VIEW_ERROR_MESSAGE } from 'helpers/types';
import useQuery from 'hooks/useQuery';

const Error = () => {
  const dispatch = useDispatch();
  const error = useSelector((state) => state.error);
  const history = useHistory();
  const query = useQuery();
  const ckoSessionId = query.get('cko-session-id');

  useEffect(() => {
    dispatch({ type: VIEW_ERROR_MESSAGE });
  }, [dispatch]);

  const displayErrorMessage = () => {
    if (ckoSessionId) return ErrorPageContent.paymentDeclinedErrorText;
    if (error.errorMessage !== '') return error.errorMessage;
    return ErrorPageContent.genericErrorText;
  };

  const displayErrorCTA = () => {
    if (error.ctaText !== '') return error.ctaText;
    return ErrorPageContent.retryButtonText;
  };

  const navigateFromError = () => {
    if (ckoSessionId) history.push('/pharmacy/dashboard');
    else if (error.link !== '') return history.push(error.link);
    else history.goBack();
  };

  return (
    <div className="coop-l-container">
      <div id="error_page" className={`${styles.error_page} coop-l-medium-8 coop-l-large-6`}>
        <h1>{ErrorPageContent.headingText}</h1>
        <p
          className={styles.intro_text}
          dangerouslySetInnerHTML={{
            __html: displayErrorMessage(),
          }}
        />
        <button
          className={`coop-btn coop-btn--primary ${styles.button}`}
          onClick={() => navigateFromError()}
          id="retrylink">
          {displayErrorCTA()}
        </button>
        <p className={styles.intro_text}>
          <span
            dangerouslySetInnerHTML={{
              __html: ErrorPageContent.extraErrorText1,
            }}
          />
          {ErrorPageContent.extraErrorText2}
          <Link to="/pharmacy/dashboard">{ErrorPageContent.extraErrorTextLink}</Link>
          {ErrorPageContent.extraErrorText3}
        </p>
      </div>
    </div>
  );
};

export default Error;
